import { Space, Spin } from "@/atoms"

import styles from "./Loader.module.scss"

export const Loader = () => (
  <Space className={styles.container}>
    <Spin />
  </Space>
)
